function getLabelAddress({
  zipCode, street, number, neighborhood, city, state,
}) {
  return `${street}, ${number} - ${neighborhood}, ${city} - ${state}, ${zipCode}`;
}

export default getLabelAddress;
